import DurationLabel from './DurationLabel';

export default DurationLabel;
